/**
 * Which account email the user arrived from. The two emails carry different
 * ASP.NET Identity tokens, and each is only accepted by its own endpoint:
 * an email-confirmation token by /auth/confirm-email (which confirms the
 * address AND sets the password), a password-reset token by
 * /auth/reset-password. Swapping them yields "Invalid token.", which the
 * backend reports as `token_expired` even on a link opened immediately.
 */
export enum SetPasswordFlow {
  ConfirmEmail = "confirm-email",
  ResetPassword = "reset-password",
}
